import React from 'react';

const AlertBanner = ({ type = 'info', message, onDismiss }) => {
  const styles = {
    info: { bg: 'bg-tertiary/10', text: 'text-tertiary', icon: 'info' },
    warning: { bg: 'bg-primary/10', text: 'text-primary', icon: 'warning' },
    critical: { bg: 'bg-error/10', text: 'text-error', icon: 'error' },
    success: { bg: 'bg-secondary/10', text: 'text-secondary', icon: 'check_circle' },
  };

  const style = styles[type] || styles.info;

  return (
    <div className={`${style.bg} rounded-2xl p-4 flex items-center justify-between backdrop-blur-sm`}>
      <div className="flex items-center gap-3">
        <span className={`material-symbols-outlined text-xl ${style.text}`}>{style.icon}</span>
        <p className={`${style.text} text-sm md:text-base font-body`}>{message}</p>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="text-slate-500 hover:text-on-surface transition-colors p-1"
          aria-label="Dismiss"
        >
          <span className="material-symbols-outlined text-sm">close</span>
        </button>
      )}
    </div>
  );
};

export default AlertBanner;
